type ScreenSize = "small" | "medium" | "large";

export const getScreenSize = (width: number): ScreenSize =>
  width <= 450 ? "small" : width > 450 && width < 800 ? "medium" : "large";
